import PresentationFile16 from '@carbon/icons-react/es/presentation-file/16';
import ShrinkScreen16 from '@carbon/icons-react/next/ShrinkScreen';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslate } from 'hooks/use-translation';

export const StatusUpdateFullscreenToggle: FC<{
  isFullScreen: boolean;
  onFullScreen: () => void;
  onExitFullScreen: () => void;
}> = ({ isFullScreen, onFullScreen, onExitFullScreen }) => {
  const translate = useTranslate();
  const enterPresentationText = translate('present.enter');
  const exitPresentationText = translate('present.exit');

  return (
    <>
      <Tooltip
        title={isFullScreen ? exitPresentationText : enterPresentationText}
      >
        <Button
          type="text"
          icon={isFullScreen ? <ShrinkScreen16 /> : <PresentationFile16 />}
          onClick={isFullScreen ? onExitFullScreen : onFullScreen}
          data-cy="status_updates_presentation_trigger"
          size="small"
        />
      </Tooltip>
    </>
  );
};
